<template lang="html">
  <div>
    <div class="container">
      <div class="form-container">
        <el-form
          ref="nodeForm"
          :model="nodeForm"
          :rules="nodeFormRules"
          label-position="right"
          label-width="120px"
        >
          <el-form-item
            label="公告标题"
            prop="title"
          >
            <el-input
              v-model="nodeForm.title"
              placeholder="默认为“节目公告”"
            ></el-input>
          </el-form-item>
          <el-form-item
            required
            label="公告正文"
            prop="content"
          >
            <el-input
              type="textarea"
              v-model="nodeForm.content"
              :autosize="{ minRows: 5, maxRows: 40 }"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="是否隐藏"
            prop="hidden"
          >
            <el-switch
              v-model="nodeForm.hidden"
            ></el-switch>
          </el-form-item>
           <el-form-item>
             <el-button
                type="default"
                @click="resetForm"
              >重置</el-button>
              <el-button
                type="primary"
                @click="submitForm"
              >提交</el-button>
            </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  // import router from '../router'
  import { Message } from 'element-ui'
import router from '../router'
  // import { MessageBox } from 'element-ui'
  
  // import Vue from 'vue'
  
  export default {
    components: {
  
    },
    data () {
      return {
        showSlug: this.$route.params.slug,
        nodeForm: {
          title: '',
          content: '',
          hidden: false
        },
        nodeFormRules: {
          title: [
            { required: false, message: '请输入标题', trigger: 'blur' },
            { max: 20, message: '长度不超过20个字符', trigger: 'blur' }
          ],
          content: [
            { required: true, message: '请输入正文', trigger: 'blur' },
            { max: 2000, message: '长度不超过2000个字符', trigger: 'blur' }
          ],
        },
      }
    },
    computed: {},
    methods: {
      resetForm: function () {
        this.$refs.nodeForm.resetFields()
      },
      submitForm: function () {
        this.$refs.nodeForm.validate((valid) => {
          if (valid) {
            window.console.log(valid)
            let nodeForm = this.nodeForm
            nodeForm.showSlug = this.showSlug
            nodeForm.created = Date.now()
            this.$api.notice.create(
              nodeForm
            ).then(res => {
              window.console.log("Notice创建成功")
              window.console.log(res)
              router.replace({
                name: 'ResultSuccess',
                params: {
                  title: '成功',
                  subTitle: '已创建节目公告',
                  action: {
                    title: '返回公告列表',
                    routeName: 'NoticeList'
                  }
                }
              })
              // Message.success({
              //   message: "公告内容创建"
              // })
            })
          } else {
            window.console.log(valid)
            Message.error({
              message: `请检查表单填写是否正确、完整`
            })
          }
        })
      }
    },
    mounted () {
      
    }
  }
</script>

<style lang="css" scoped>
</style>
